import ReactMarkdown from "react-markdown";
import { WEB_APP_API_URL } from "./constants";

class Utils {
  makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getParams() {
    var params = {};
    var parser = document.createElement("a");
    const url = document.URL;
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  }

  replaceVariableString = (text, data) => {
    // First transform text to string :
    if (typeof text !== "string") {
      text = text || "";
      text = text.toString();
    }

    let matches = text.match(/\{\{[A-z,1-9,_,.]*\}\}/g);

    if (matches) {
      matches = matches.map((x) => {
        return {
          match: x,
          path: x.substring(2, x.length - 2).split("."),
        };
      });

      matches.forEach((x) => {
        let val = data;
        for (const k of x["path"]) {
          val = val[k];
          if (val === undefined) {
            break;
          }
        }

        if (val !== undefined) {
          text = text.replace(x["match"], val);
        }
      });
    }
    return text;
  };

  textManager(text, data, markdown = true) {
    /**
     * This function is used to manage the text of the module. It can be used to replace variables in the text. It can also be used to convert the text to markdown.
     * @param {string} text
     * @param {object} data
     * @param {boolean} markdown
     * @return {string}
     */
    if (typeof text === "object") {
      text = { ...text };
    }
    if (typeof text === "object") {
      Object.keys(text).forEach((x) => {
        if (!text[x] || text[x].length < 1) {
          delete text[x];
        }
      });
      const lgs = navigator.languages.map((x) =>
        x.includes("zh") ? x : x.split("-")[0]
      );

      text = { ...text };

      if (this.getParams().hasOwnProperty("lg")) {
        lgs.unshift(
          this.getParams()["lg"].includes("zh")
            ? this.getParams()["lg"]
            : this.getParams()["lg"].split("-")[0]
        );
      }

      for (const lg of lgs) {
        if (text.hasOwnProperty(lg)) {
          text = text[lg];
          break;
        }
      }

      if (typeof text !== "string") {
        text = text[Object.keys(text)[0]];
      }
    }

    if (markdown) {
      return (
        <ReactMarkdown>{this.replaceVariableString(text, data)}</ReactMarkdown>
      );
    } else {
      return this.replaceVariableString(text, data);
    }
  }

  translate(translations) {
    return fetch(WEB_APP_API_URL + "/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(translations),
    }).then((response) => response.json());
  }

  wrapAsync(dispatch) {
    return function (action) {
      if (action instanceof Function) {
        return action(dispatch);
      }
      return dispatch(action);
    };
  }

  /**
   *
   * @param text {string|Object}
   * @returns {string|*}
   */
  textAccordingToLanguage(text) {
    const userLanguage = localStorage.getItem("userLanguage") || "en";

    if (typeof text === "object") {
      return text[userLanguage] || text["en"];
    } else if (typeof text === "string") {
      return text;
    } else {
      return "";
    }
  }
}

const utils = new Utils();

export default utils;
